import DeadlineRule from "../../entities/deadlineRule";

/**
 * DeadlineRule actions
 *
 * Call order:
 *
 * DEADLINERULE_SAVE_QUEUE:	adds the item to the save queue
 * --> DEADLINERULE_SAVE:	modifies the state
 * --> DEADLINERULE_SAVE_SUCCESS: if all went well
 * --> DEADLINERULE_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail DEADLINERULE_SAVE_QUEUE is during the call to DEADLINERULE_SAVE,
 * as adding an item to the queue should never fail.
 */

export const DEADLINERULE_FETCH_ONE_QUEUE: any = 'DEADLINERULE_FETCH_ONE_QUEUE';
export const DEADLINERULE_FETCH_SUCCESS: any = 'DEADLINERULE_FETCH_SUCCESS';
export const DEADLINERULE_FETCH_FAILURE: any = 'DEADLINERULE_FETCH_FAILURE';
export const DEADLINERULE_FETCH_ONE_SUCCESS: any = 'DEADLINERULE_FETCH_ONE_SUCCESS';
export const DEADLINERULE_FETCH_ONE_FAILURE: any = 'DEADLINERULE_FETCH_ONE_FAILURE';

export const DEADLINERULE_SAVE: any = 'DEADLINERULE_SAVE';
export const DEADLINERULE_SAVE_QUEUE: any = 'DEADLINERULE_SAVE_QUEUE';
export const DEADLINERULE_SAVE_SUCCESS: any = 'DEADLINERULE_SAVE_SUCCESS';
export const DEADLINERULE_SAVE_FAILURE: any = 'DEADLINERULE_SAVE_FAILURE';

export const DEADLINERULE_SAVE_MANY: any = 'DEADLINERULE_SAVE_MANY';
export const DEADLINERULE_SAVE_MANY_QUEUE: any = 'DEADLINERULE_SAVE_MANY_QUEUE';
export const DEADLINERULE_SAVE_MANY_SUCCESS: any = 'DEADLINERULE_SAVE_MANY_SUCCESS';
export const DEADLINERULE_SAVE_MANY_FAILURE: any = 'DEADLINERULE_SAVE_MANY_FAILURE';

export const DEADLINERULE_REMOVE: any = 'DEADLINERULE_REMOVE';
export const DEADLINERULE_REMOVE_QUEUE: any = 'DEADLINERULE_REMOVE_QUEUE';
export const DEADLINERULE_REMOVE_SUCCESS: any = 'DEADLINERULE_REMOVE_SUCCESS';
export const DEADLINERULE_REMOVE_FAILURE: any = 'DEADLINERULE_REMOVE_FAILURE';

export const DEADLINERULE_RESTORE: any = 'DEADLINERULE_RESTORE';
export const DEADLINERULE_RESTORE_QUEUE: any = 'DEADLINERULE_RESTORE_QUEUE';
export const DEADLINERULE_RESTORE_SUCCESS: any = 'DEADLINERULE_RESTORE_SUCCESS';
export const DEADLINERULE_RESTORE_FAILURE: any = 'DEADLINERULE_RESTORE_FAILURE';

export const DEADLINERULE_RESTORE_MANY: any = 'DEADLINERULE_RESTORE_MANY';
export const DEADLINERULE_REMOVE_MANY: any = 'DEADLINERULE_REMOVE_MANY';

/* Fetch actions */
export const fetchDeadlineRuleSuccess = (deadlineRules: DeadlineRule[], partial: boolean, lastFetch: number) => ({type: DEADLINERULE_FETCH_SUCCESS, deadlineRules, partial, lastFetch});
export const fetchDeadlineRuleFailure = (err: any) => {
		console.error('DeadlineRuleAction: fetchDeadlineRuleFailure', err);
		return {type: DEADLINERULE_FETCH_FAILURE, err};
};
export const fetchOneDeadlineRuleQueue = (deadlineRuleId: string) => ({type: DEADLINERULE_FETCH_ONE_QUEUE, deadlineRuleId});
export const fetchOneDeadlineRuleSuccess = (deadlineRule: DeadlineRule) => ({type: DEADLINERULE_FETCH_ONE_SUCCESS, deadlineRule});
export const fetchOneDeadlineRuleFailure = (id: string, err: any) => {
		console.error('DeadlineRuleAction: fetchOneDeadlineRuleFailure', err);
		return {type: DEADLINERULE_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveDeadlineRule = (deadlineRule: DeadlineRule) => {
    // console.debug('⮂ DEADLINERULE_SAVE action', deadlineRule?.id);
    return {type: DEADLINERULE_SAVE, deadlineRule};
}
export const saveDeadlineRuleQueue = (deadlineRule: DeadlineRule) => {
    // console.debug('⮂ DEADLINERULE_SAVE_QUEUE action', deadlineRule?.id);
    return {type: DEADLINERULE_SAVE_QUEUE, deadlineRule};
}
export const saveDeadlineRuleSuccess = (deadlineRule: DeadlineRule) => {
    // console.debug('⮂ DEADLINERULE_SAVE_SUCCESS action', deadlineRule?.id);
    return {type: DEADLINERULE_SAVE_SUCCESS, deadlineRule};
}
export const saveDeadlineRuleFailure = (deadlineRule: DeadlineRule, status: number, message: string) => {
    console.warn(`⮂ DEADLINERULE_SAVE_FAILURE error saving deadlineRule: HTTP ${status}: ${message}`, deadlineRule?.id);
    return {type: DEADLINERULE_SAVE_FAILURE, deadlineRule, status, message};
};

/* SaveMany actions */
export const saveManyDeadlineRules = (deadlineRules: DeadlineRule[]) => {
    // console.debug('⮂ DEADLINERULE_SAVE_MANY action', deadlineRules?.map(deadlineRule => deadlineRule?.id).join(','));
    return {type: DEADLINERULE_SAVE_MANY, deadlineRules};
}
export const saveManyDeadlineRulesQueue = (deadlineRules: DeadlineRule[]) => {
    // console.debug('⮂ DEADLINERULE_SAVE_MANY_QUEUE action', deadlineRules?.map(deadlineRule => deadlineRule.id).join(','));
    return {type: DEADLINERULE_SAVE_MANY_QUEUE, deadlineRules};
}

export const saveManyDeadlineRulesSuccess = (deadlineRules: DeadlineRule[]) => {
    // console.debug('⮂ DEADLINERULE_SAVE_MANY_SUCCESS action', deadlineRules?.map(deadlineRule => deadlineRule.id).join(','));
    return {type: DEADLINERULE_SAVE_MANY_SUCCESS, deadlineRules};
}
export const saveManyDeadlineRulesFailure = (deadlineRules: DeadlineRule[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_DEADLINERULES_FAILURE Error saving deadlineRules: HTTP ${status}: ${message}`, deadlineRules?.map(deadlineRule => deadlineRule.id).join(','));
		return {type: DEADLINERULE_SAVE_MANY_FAILURE, deadlineRules, status, message};
};

/* Remove actions */
export const removeDeadlineRule = (deadlineRule: DeadlineRule) => ({ type: DEADLINERULE_REMOVE, deadlineRule });
export const removeDeadlineRuleQueue = (deadlineRule: DeadlineRule) => ({ type: DEADLINERULE_REMOVE_QUEUE, deadlineRule });
export const removeDeadlineRuleSuccess = (deadlineRule: DeadlineRule) => ({ type: DEADLINERULE_REMOVE_SUCCESS, deadlineRule });
export const removeDeadlineRuleFailure = (deadlineRule: DeadlineRule, status: number, message: string) => {
	console.error(`Redux: removeDeadlineRuleFailure Error removing deadlineRule: HTTP ${status}: ${message}`);
	return ({ type: DEADLINERULE_REMOVE_FAILURE, deadlineRule, status, message });
};

/* Restore actions */
export const restoreDeadlineRule = (deadlineRule: DeadlineRule) => ({ type: DEADLINERULE_RESTORE, deadlineRule });
export const restoreDeadlineRuleQueue = (deadlineRule: DeadlineRule) => ({ type: DEADLINERULE_RESTORE_QUEUE, deadlineRule });
export const restoreDeadlineRuleSuccess = (deadlineRule: DeadlineRule) => ({ type: DEADLINERULE_RESTORE_SUCCESS, deadlineRule });
export const restoreDeadlineRuleFailure = (deadlineRule: DeadlineRule, status: number, message: string) => {
	console.error(`Redux: restoreDeadlineRuleFailure Error restoring deadlineRule: HTTP ${status}: ${message}`);
	return ({ type: DEADLINERULE_RESTORE_FAILURE, deadlineRule, status, message });
};

/* RestoreMany actions */
export const restoreManyDeadlineRules = (deadlineRules: DeadlineRule[]) => ({ type: DEADLINERULE_RESTORE_MANY, deadlineRules });

/* RemoveMany actions */
export const removeManyDeadlineRules = (deadlineRules: DeadlineRule[]) => ({ type: DEADLINERULE_REMOVE_MANY, deadlineRules });